"use client";

import React from "react";
import { LineChart, Megaphone, ShoppingBag } from "lucide-react";
import { Area, AreaChart, CartesianGrid, XAxis } from "recharts";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const chartData = [{
  month: "Янв",
  success: 40
}, {
  month: "Фев",
  success: 30
}, {
  month: "Мар",
  success: 45
}, {
  month: "Апр",
  success: 25
}, {
  month: "Май",
  success: 55
}, {
  month: "Июн",
  success: 40
}, {
  month: "Июл",
  success: 60
}];
const chartConfig = {
  success: {
    label: "Уровень успеха",
    color: "var(--color-chart-2)"
  }
} satisfies ChartConfig;
export default function ServicesOffered() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const services = [{
    title: "Промо‑кампании",
    description: "Эффективные рекламные стратегии, направленные на повышение узнаваемости бренда и привлечение клиентов.",
    icon: Megaphone,
    hasChart: false
  }, {
    title: "Мерчандайзинг",
    description: "Стратегическое размещение товаров и планирование запасов для максимальной видимости и оборота продаж во всех каналах.",
    icon: ShoppingBag,
    hasChart: false
  }, {
    title: "Аналитика и инсайты",
    description: "Принятие решений на основе данных с отслеживанием в реальном времени и прогнозным моделированием для будущего роста.",
    icon: LineChart,
    hasChart: true
  }];
  return <section id="services-offered" ref={ref} className={`dark bg-background/50 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1567030/img/merchandising_retail_display.png)] bg-cover bg-center bg-no-repeat bg-fixed bg-blend-overlay py-24 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4">
        <div className="mb-16 text-center">
          <h2 className="text-foreground text-3xl font-bold tracking-tight sm:text-4xl">Услуги</h2>
          <p className="mt-4 text-lg !text-[hsl(0,0%,100%)]">
            Комплексные решения, адаптированные для роста современного бизнеса.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-3">
          {services.map((service, i) => <div key={service.title} data-index={i} className="group relative">
              <Card className="bg-card/10 border-border/50 hover:border-b-(--color-chart-2) hover:shadow-[0_0_20px_-5px_var(--color-chart-2)] h-full overflow-hidden border backdrop-blur-md transition-all duration-300 ease-[cubic-bezier(0.175,0.885,0.32,1.275)] hover:-translate-y-2">
                <CardHeader>
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-slate-800/50 ring-1 ring-slate-700">
                    <service.icon className="text-primary h-6 w-6 stroke-[2px]" aria-hidden="true" />
                  </div>
                  <CardTitle className="text-foreground text-xl font-semibold">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm font-medium leading-relaxed !text-[hsl(0,0%,100%)]">
                    {service.description}
                  </CardDescription>
                  {i === 0 && <img src="https://profi-agency.site/wp-content/uploads/2026/03/lx2ujmybkk3svhbgi6qogafkrfweu622.jpg?v=dz4xgl2t0vh" alt="Promotional event" className="mt-6 w-full rounded-md object-cover !h-[250px]" />}
                  {i === 1 && <img src="https://profi-agency.site/wp-content/uploads/2026/03/d6008ecc79dfe68c3fdb27eef03555b4469f54d8e7r.jpg?v=996bsmdw3nh" alt="Promotional activities" className="mt-6 w-full rounded-md object-cover !h-[250px]" />}

                  {service.hasChart && <div className="mt-6 w-full overflow-hidden rounded-md bg-slate-900/50 p-2 ring-1 ring-slate-800 !h-[180px]">
                      <ChartContainer config={chartConfig} className="h-full w-full">
                        <AreaChart data={chartData} margin={{
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                  }}>
                          <defs>
                            <linearGradient id="fillSuccess" x1="0" y1="0" x2="0" y2="1">
                              <stop offset="5%" stopColor="var(--color-chart-2)" stopOpacity={0.8} />
                              <stop offset="95%" stopColor="var(--color-chart-2)" stopOpacity={0.1} />
                            </linearGradient>
                          </defs>
                          <CartesianGrid vertical={false} strokeOpacity={0.1} />
                          <XAxis dataKey="month" tickLine={false} axisLine={false} tickMargin={8} hide />
                          <ChartTooltip cursor={false} content={<ChartTooltipContent indicator="dot" />} />
                          <Area dataKey="success" type="natural" fill="url(#fillSuccess)" fillOpacity={0.4} stroke="var(--color-chart-2)" strokeWidth={2} stackId="a" />
                        </AreaChart>
                      </ChartContainer>
                    </div>}
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}